<template>
  <div class="home">
    <transition name="pop">
      <div class="login" v-if="ready">

        <div class="login__brand">
          <img src="@/assets/logo.png" alt="Event USA">
        </div>

        <div class="login__card eu-card">
          <header class="login__head">
            <h1 class="login__title">Scanner Access</h1>
            <p class="login__sub">Enter the event password to begin scanning.</p>
          </header>

          <transition name="pop">
            <div class="login__error" v-if="error" role="alert">
              <MDBIcon icon="exclamation-circle" />
              <span>{{error}}</span>
            </div>
          </transition>

          <form @submit.prevent="submit" class="login__form">
            <fieldset :disabled="busy">
              <MDBSpinner class="position-absolute top-50 start-50" v-if="busy"></MDBSpinner>
              <MDBInput
                class="mb-3"
                type="password"
                label="Password"
                size="lg"
                autocomplete="current-password"
                v-model="password" />
              <button type="submit" class="eu-btn eu-btn--block eu-btn--lg">
                {{ busy ? 'Checking…' : 'Log In' }}
              </button>
            </fieldset>
          </form>
        </div>

        <p class="login__foot">Event USA · Tailgate Redemption</p>
      </div>
    </transition>
  </div>
</template>

<script>
 import {MDBIcon, MDBSpinner, MDBInput , MDBCol, MDBRow, MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn,MDBModal, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter} from 'mdb-vue-ui-kit';
 import { ref } from 'vue';
export default {
  name: 'Home',
  components: {
    MDBIcon, MDBSpinner, MDBInput, MDBCol, MDBRow, MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn,MDBModal, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter
  },
  data(){
    return {
      busy:false,
      ready:false,
      password:'',
      error:''
    }
  },
  async mounted(){
    if(this.$route.path=='/'&&!_.isEmpty(localStorage.getItem('token'))){ 
        this.$router.push('/scan'); 
    }
    this.ready = true;
    
  },
  methods:{
    async submit(){
      this.error = '';
      this.busy = true;
      try{
        let req = await fetch(`${this.$store.state.api}/verify_password/${this.password}`,{
          method:'GET',
          headers:{
            'Authorization':`Basic ${btoa(`fpadmin:iDsPtHEYxGVi3OgassYOu1GK`)}`,
          },
        });
        let res = await req.json();
        console.log(res)
        if(res.hasOwnProperty('token')){
          localStorage.setItem('token', res.token);
          localStorage.setItem('appPassword', res.appPassword);
          this.ready = false;
          await Sleep(500);
          this.$router.push('/scan');
          return; // stay busy through the transition
        }
        this.error = 'Incorrect Password';
      }
      catch(err){
        // Without this the form stays disabled forever on a dropped connection.
        console.error('login failed', err);
        this.error = 'Could not reach the server. Check your connection and try again.';
      }
      this.busy = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.home{
  min-height:100vh;
  min-height:100dvh;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:2rem 1.25rem;
}

.login{
  width:100%;
  max-width:420px;
  display:flex;
  flex-direction:column;
  align-items:stretch;
  gap:1.75rem;
}

.login__brand{
  display:flex;
  justify-content:center;
  img{
    max-width:220px;
    width:100%;
    height:auto;
  }
}

.login__card{
  padding:2rem;
}

.login__head{
  margin-bottom:1.75rem;
  text-align:center;
}

.login__title{
  margin:0 0 .4rem;
  font-size:1.4rem;
  font-weight:700;
  letter-spacing:-.02em;
  color:var(--text);
}

.login__sub{
  margin:0;
  font-size:.9rem;
  line-height:1.5;
  color:var(--text-muted);
}

.login__error{
  display:flex;
  align-items:center;
  gap:.6rem;
  margin-bottom:1.25rem;
  padding:.85rem 1rem;
  border:1px solid var(--danger-border);
  border-radius:var(--r-md);
  background:var(--danger-soft);
  color:var(--danger);
  font-size:.9rem;
  font-weight:600;
}

.login__form{
  position:relative;
}

.login__foot{
  margin:0;
  text-align:center;
  font-size:.78rem;
  letter-spacing:.08em;
  text-transform:uppercase;
  color:var(--text-subtle);
}

@media (max-width:480px){
  .login__card{ padding:1.5rem; }
}
</style>
